import type {SocialAccount} from '@Components/social-media/account.vo';
import type {TikTokPrivacySettings} from '@Components/social-media/post.vo';

export interface TiktokPrivacySelectorProps {
  account: SocialAccount;
  onSelectOption?: (selectedOption: TikTokPrivacySettings) => void;
  isLoading?: boolean;
}

export const PRIVACY_SELECTOR_SKELETON_WIDTH = 96;
export const PRIVACY_SELECTOR_SKELETON_HEIGHT = 30;
export const PRIVACY_SELECTOR_SKELETON_CORNER_RADIUS = '8px';
